import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    siteVisibleSection:0,
    siteReady:false,
    siteData:[],
    siteDic:[],
    siteLang: "en",
    siteDataReady:false,
    localeRx: /^\w{2}-\w{2}$/,    
    xSelectedPlatform:-1
  },
  mutations: {
    // /SET_DICTONARY
    SET_VISIBLE_SECTION(state,secIndex)
    {
      state.siteVisibleSection = secIndex;
    },

    SET_SITE_READY(state,isSiteReady)
    {
      state.siteReady = isSiteReady;
    },

    SET_SITE_LANG(state,language)
    {
      state.siteLang = language;
    },
    SET_DICTONARY(state,dictionaryData)
    {
      state.siteDataReady = true;
      state.siteDic = dictionaryData;      
    },
    SET_SITE_DATA(state,siteData)
    {
      state.siteData = siteData;      
    },
    SET_PLATFORM(state,index)
    {
      state.xSelectedPlatform = index;
    }
  },
  actions: {
    setVisibleSection({state,commit,dispatch},secIndex)
    {
      commit('SET_VISIBLE_SECTION',secIndex);
    },
    setSiteReady({state,commit,dispatch},isSiteReady)
    {
      commit('SET_SITE_READY',isSiteReady);
    },
    xSetPlatform({state,commit,dispatch},index)
    {
        commit('SET_PLATFORM',index);
    },
    loadSiteData({state,commit,dispatch},language)
    {
      var CollectionName = "Default";
      var apiURL = "site_data.json";
      //var apiURL = "site_data_"+language+".json?v=2000";
      fetch(apiURL, 
        {
          method: "GET",
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
      })
      .then(function(response) { return response.json();})
      .then(function(response)
      {
        commit('SET_SITE_LANG',language);
        commit('SET_SITE_DATA',response);
        dispatch('loadDictionary',language);
      }        
      );
    },
    loadDictionary({state,commit,dispatch})
    {
      var apiURL = "site_dictionary.json";
      fetch(apiURL, 
      {
          method: "GET",cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
      })
      .then(function(response){return response.json();})
      .then(function(response){commit('SET_DICTONARY',response);}        
      );
    },    
  }
  });
